import type { FacilityReportStatus } from '@/models/types/report/facility-report-state'

enum AlarmActionType {
    Ack,
    Archive,
    NotifyToPlant,
}

enum DeviceActionType {
    TurnOn,
    TurnOff
}

type AlarmAction = { alarmId: number; actionType: AlarmActionType }

type ReportAction = { reportId: number; statoReport: FacilityReportStatus }

type DeviceAction = { deviceId: number; actionType: DeviceActionType }

export { AlarmActionType, DeviceActionType, type AlarmAction, type ReportAction, type DeviceAction }
